import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_FR_UQ || "uq.fr.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_FR_UQ || 24138,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_FR_UQ || 24139,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_FR_UQ ||
    "1:160978693362:web:44a3eb597678f73247346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-ES85DP7FQX" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.FR, LANGUAGE.EN]
};

export default _countryEnv;
